<template>
  <div class="part-item projectBuilding">
    <p class="part-title">诚信承诺
      <a
        v-show="isShow"
        href="javascript:;"
        @click="showUploadImgWindow"
      ><i class="icon iconfont">&#xe660;</i>编辑</a>
    </p>
    <div class="part-content">
      <p style="margin-bottom: 10px;">本团队承诺：申报课程的实验教学设计具有一定的原创性，课程所属学校对本实验课程内容（包括但不限于实验软件、操作系统、教学视频、教学课件、辅助参考资料、实验操作手册、实验案例、测验试题、实验报告、答疑、网页宣传图片文字等组成本实验课程的一切资源）享有著作权，保证所申报的课程或其任何一部分均不会侵犯任何第三方的合法权益。</p>
      <p
        class="fangsong commitment-incharge"
        style="text-align: right;"
      >实验教学课程负责人（签字）：
        <a
          style="color: #73D6CA;text-decoration: underline;"
          v-if="!formInfo.promise_file"
          href="javascript:;"
        >{{isShow?'请上传手签图片':''}}</a>
        <template v-else>
          <img
            class="signPic"
            :src="formInfo.promise_file.path"
            alt=""
          >
          <span
            v-show="isShow"
            @click="savePromise(0)"
            class="del-icon"
          >x</span>
        </template>
      </p>
      <p
        class="fangsong commitment-year"
        style="text-align: right;"
      >
        {{formatTime(formInfo.promise_file.date)}}
      </p>
    </div>

    <div
      id="file-upload-overlay"
      :style="showWindow.bigFile ? 'display: block' : ''"
    >
      <div class="file-upload-bg"></div>
      <div class="file-upload">

        <div class="file-upload-type">允许上传的文件扩展名：jpg, png</div>
        <div
          class="file-upload-close"
          @click="hideFileWindow"
        >×</div>
        <span
          class="file_uploadBtn"
          id="file_uploadBtn"
          style="display: block;"
        >
          选择文件<input
            type="file"
            id="file_fileInput"
            accept=".jpg,.png"
            ref="docFile"
            style="display: block;"
            @change="fileChange"
          >
        </span>
        <div
          class="fileBox"
          id="file_uploadBox"
          style="display: block;"
        >
          <span
            class="pauseBtn"
            id="file_pauseBtn"
            style="display: none;"
          >暂停</span>
          <span
            class="goBtn"
            id="file_goBtn"
            style="display:none;"
          >继续</span>
          <div
            class="filename"
            id="file_filename"
            style="display: none;"
          ></div>
          <div
            class="pbar"
            :style="showWindow.bigFileOption.showProgress ? 'display: block' : 'display: none'"
          >
            <div
              class="progress"
              id="file_progress"
              :style="'width: ' + Math.ceil(showWindow.bigFileOption.progressValue * 4.2) + 'px;'"
            ></div>
            <div id="file_percent">{{ showWindow.bigFileOption.progressValue }}%</div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <div
      class="form_overlay"
      id="form_overlay"
      :style="classUploadImgWindow"
    >
      <div class="form_overlay_bg"></div>
      <div
        class="form_panel editor"
        style="width: 550px;"
      >
        <div class="form_title">编辑</div>
        <div class="form_content">
          <form id="itemForm">
            <div class="item">
              <span class="label"><i class="require"></i>上传手签图片:</span>
              <div class="item-box">
                <input
                  type="text"
                  disabled="disabled"
                  v-model="formPromise.path"
                >
                <span
                  class="button"
                  id="uploadImg"
                  @click="showFileWindow()"
                >添加图片</span>
              </div>
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>选择日期:</span>
              <div class="item-box">
                <input
                  type="datetime-local"
                  v-model="formPromise.date"
                >
              </div>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            id="form_close"
            @click="hideUploadImgWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            id="form_submit"
            @click="savePromise(1)"
          >提交</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExperimentMaintainPromise',
  props: ['isShow', 'expId'],
  data () {
    return {
      editorConfig: {
        UEDITOR_HOME_URL: '/UE/',
        serverUrl: this.$store.state.uEditorServerUrl,
        autoHeight: true,
        initialFrameWidth: '100%',
        initialFrameHeight: 300
      },
      formInfo: {
        promise_file: ''
      },
      formPromise: {
        path: '',
        date: ''
      },
      showWindow: {
        bigFile: false,
        bigFileOption: {
          showProgress: false,
          progressValue: 0
        }
      },
      classUploadImgWindow: {}
    }
  },
  methods: {
    formatTime(val) {
      if (val) {
        const valIndex = val.indexOf('T')
        const newStr = val.slice(0, valIndex)
        const valArr = newStr.split('-')
        return valArr[0] + '年' + valArr[1] + '月' + valArr[2] + '日'
      } else {
        return ' 年' + ' 月' + ' 日'
      }
    },
    showUploadImgWindow() {
      this.classUploadImgWindow = {
        visibility: 'visible'
      }
    },
    hideUploadImgWindow() {
      this.classUploadImgWindow = {}
    },
    formatShowWindow(tag) {
      if (tag) {
        return {
          visibility: 'visible'
        }
      } else {
        return {}
      }
    },
    async getInfo() {
      const url = '/allowany/experiment/' + this.expId + '/'
      await this.$http.get(url).then(async (data) => {
        this.formInfo = data
        this.formInfo.promise_file = data.promise_file ? JSON.parse(data.promise_file) : ''
      }).catch((error) => {
        console.log(error)
      })
    },
    showFileWindow() {
      if (this.isShow) {
        this.showWindow.bigFile = true
      }
    },
    hideFileWindow() {
      this.showWindow.bigFile = false
    },
    async fileChange() {
      if (this.$store.state.max_file_size && this.$refs.docFile.files[0].size > this.$store.state.max_file_size) {
        alert('文件大小超过限制！')
        return false
      }
      this.showWindow.bigFileOption.showProgress = true
      const fileRealName = this.$refs.docFile.files[0].name
      const uploadUrl = '/info_files/' + fileRealName
      await this.$http.put(uploadUrl, this.$refs.docFile.files[0], {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (e) => {
          this.showWindow.bigFileOption.progressValue = Math.ceil(e.loaded / e.total * 100)
        }
      }).then((data) => {
        this.showWindow.bigFileOption.showProgress = false
        this.showWindow.bigFileOption.progressValue = 0
        this.hideFileWindow()
        // 此处处理data
        // var myDate = new Date()
        this.formPromise.path = data
      }).catch((error) => {
        console.log(error)
        this.showWindow.bigFileOption.showProgress = false
        this.showWindow.bigFileOption.progressValue = 0
        this.hideFileWindow()
        this.$layer.msg('上传失败！')
      })
    },
    async savePromise(type) {
      if (!type) {
        this.formInfo.promise_file = ''
      }
      if (type && !this.formPromise.path) {
        this.$layer.msg('请上传手签图片！')
        return
      }
      if (type && !this.formPromise.date) {
        this.$layer.msg('请选择日期！')
        return
      }
      const url = '/experiment/' + this.expId + '/'
      await this.$http.put(url, {
        promise_file: type ? JSON.stringify(this.formPromise) : ''
      }).then((data) => {
        if (data.id) {
          this.getInfo()
          this.hideUploadImgWindow()
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    }
  },
  async mounted() {
    await this.getInfo()
  }
}
</script>

<style scoped src="../../../../assets/css/project-detail.css"></style>
<style scoped src="../../../../assets/css/table.css"></style>
<style scoped src="../../../../assets/css/chunkUpload.css"></style>
<style scoped src="../../../../assets/css/project-manage.css"></style>

<style lang="less" scoped>
.content .container {
  width: 1200px;
  margin: 0 auto;
  visibility: visible;
}

.center_content {
  .box-wrap {
    margin-top: 20px;
    padding: 40px;
    background: #fff;
    box-sizing: border-box;
  }

  .title {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-right: 160px;
    padding-left: 20px;

    .title-btns {
      position: absolute;
      top: 0;
      right: 0;

      > a {
        margin-right: 10px;
        font-size: 14px;
        font-weight: lighter;
        color: #3399ff;
        cursor: pointer;

        i {
          font-size: 14px;
          margin-right: 5px;
        }
      }
    }
  }

  .title:before {
    content: "";
    width: 4px;
    height: 1em;
    background-color: #73D6CA;
    position: absolute;
    left: 0;
    top: 16px;
  }

  .mbox .lBox {
    float: left;
    width: 600px;

    .detail-base {
      font-size: 16px;
      padding: 20px 0;
      height: 376px;
      box-sizing: border-box;
      overflow-y: auto;

      .detail-item {
        display: inline-block;
        margin-right: 30px;
        padding: 10px 0;
      }

      .detail-intro {
        padding: 10px 0;

        .label {
          float: left;
        }

        p {
          padding-left: 80px;
        }
      }

      .clearfix:after {
        content: ".";
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
        overflow: hidden;
      }
    }
  }

  .label {
    width: 100px;
    padding-right: 10px;
  }

  .mbox .rBox {
    float: right;
    width: 460px;

    .preview {
      padding: 6px 20px;
      border: 1px solid #73D6CA;
      color: #73D6CA;
      border-radius: 3px;
    }

    .submit {
      padding: 7px 20px;
      background: #73D6CA;
      color: #fff;
      border-radius: 3px;
    }

    .imgCover {
      width: 100%;
      height: 306px;
      margin-top: 10px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .upload {
      width: 140px;
      height: 40px;
      line-height: 40px;
      display: block;
      margin: 10px auto;
      text-align: center;
      background: #21b295;
      color: #fff;
      border-radius: 3px;
      cursor: pointer;
      font-size: 16px;
    }
  }
  .part-content {
    .part-new-table {
      margin: 10px 0;
      border: 1px solid #ebebeb;
      width: 100%;
      max-width: 100%;
      border-spacing: 0;
      border-collapse: collapse;
      background-color: transparent;
      tr th {
        background-color: #f8faff;
        color: #999;
        font-weight: normal;
      }
    }
    .part-new-table tr th,
    .part-new-table tr td {
      padding: 8px;
      line-height: 1.42857143;
      vertical-align: middle;
      border: 1px solid #ebebeb;
      text-align: center;
    }
  }
  .item-box {
    float: left;
    width: 302px;
    position: relative;
  }

  .uploadImgPreview li img {
    width: 100%;
    margin-top: 5px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
    overflow: hidden;
  }

  .video-box {
    .lBox {
      float: left;
      width: 500px;

      .upload {
        padding: 6px 20px;
        background: #73D6CA;
        color: #fff;
        border-radius: 3px;
      }
    }

    .video-wrap {
      width: 400px;
      height: 226px;
      margin: 10px auto 0;
      background: #000;

      video {
        width: 100%;
        height: 100%;
      }
    }

    .rBox {
      float: right;
      width: 500px;

      .upload {
        padding: 6px 20px;
        background: #73D6CA;
        color: #fff;
        border-radius: 3px;
      }
    }
  }

  .menu-box {
    overflow: hidden;
    border-bottom: 1px solid #eee;

    ul {
      li {
        text-align: center;
        float: left;
        margin-right: 10px;

        a {
          display: block;
          padding: 10px;
          font-size: 16px;
          color: #002900;
          text-decoration: none;
          border-bottom: 3px solid #fff;
        }

        &:hover a {
          color: #73D6CA;
          border-color: #73D6CA;
        }
      }

      .onActive {
        a {
          color: #73D6CA;
          border-color: #73D6CA;
        }
      }
    }
  }

  .part {
    min-height: 390px;
    margin-top: 30px;
  }
}
.form_contentEdit .label {
  width: 100px !important;
}
.form_content .k-container {
  max-width: 640px;
  width: 640px;
  .item-table {
    width: 640px;
    input {
      width: 100%;
      border: none;
    }
  }
  .item-table th,
  .item-table td {
    border-bottom: 1px solid #ddd;
    border-right: 1px solid #ddd;
    text-align: center;
    padding-bottom: 1px;
  }
}
.teachItem {
  p {
    font-weight: 600;
  }
  .link {
    color: #0b80ff;
    margin: 10px 0;
    display: block;
  }
}
.teachEdit {
  .m-r {
    color: #333333;
    font-weight: 500;
    display: inline-block;
    width: 150px;
    input {
      position: relative;
      top: -1px;
      margin-right: 7px;
    }
  }
  .file {
    color: #0b80ff;
    display: block;
    .del {
      margin-left: 10px;
      font-size: 22px;
      color: #c7254e;
      cursor: pointer;
      margin: 0;
      background: transparent;
      top: 3px;
      position: relative;
    }
  }
  .upload {
    display: block;
    text-align: center;
    width: 55px;
    line-height: 30px;
    background: #f19830;
    color: #fff;
    cursor: pointer;
  }
}
.warn {
  p {
    font-size: 12px;
    color: #df3d3e;
  }
  span {
    font-size: 12px;
    color: #337ab7;
    cursor: pointer;
  }
}
.NumCount {
  display: inline-block;
  text-align: center;
  width: 40px;
  border-bottom: 1px solid #999;
}
.teach_Item {
  color: #666;
  .text {
    width: 40px !important;
    height: 20px !important ;
    line-height: 23px !important;
    border: none !important;
    text-align: center;
    border-bottom: 1px solid #999 !important;
  }
}
.form_overlay {
  z-index: 100 !important;
}

.file-upload {
  z-index: 200 !important;
}

.menu-list > li.on a,
.menu-list > li:hover a {
  color: #73D6CA !important;
  border-color: #73D6CA !important;
}
.signPic {
  max-height: 20px;
  max-width: 120px;
  vertical-align: middle;
  display: inline-block;
  margin-top: -3px;
  margin-right: 25px;
}
.del-icon {
  color: #ff0000;
  position: relative;
  display: inline-block;
  border: 1px solid #ddd;
  font-size: 12px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 20px;
  right: 17px;
  top: -12px;
  cursor: pointer;
}
.url_link {
  flex: 1;
  overflow-x: auto;
  white-space: nowrap;
}
.url_link::-webkit-scrollbar {
  display: none;
}
.form_control {
  text-align: center;
}
.form_control a {
  float: none;
  display: inline-block;
}
.addOtherUser {
  display: inline-block;
  color: #ffffff;
  margin-left: 15px;
  height: 34px;
  line-height: 34px;
  padding: 0 15px;
  border-radius: 4px;
  background-color: #028c8c;
  border-color: #028c8c;
  cursor: pointer;
}
.infor span {
  font-size: 14px;
  color: #333;
  margin-right: 20px;
  display: inline-block;
  margin-bottom: 10px;
  display: inline-block;
}
.infor span i {
  color: #999;
}
.person {
  position: relative;
  overflow: hidden;
}
.person_symbol {
  position: absolute;
  left: -20px;
  top: 4px;
  background: #ff2424;
  color: #fff;
  width: 70px;
  text-align: center;
  font-size: 12px;
  transform: rotate(-45deg);
  -ms-transform: rotate(-45deg); /* Internet Explorer 9*/
  -moz-transform: rotate(-45deg); /* Firefox */
  -webkit-transform: rotate(-45deg); /* Safari 和 Chrome */
  -o-transform: rotate(-45deg); /* Opera */
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
}
.tips {
  margin-bottom: 10px;
  color: rgb(144, 144, 144);
}
.content_underline {
  text-decoration: underline;
  margin: 0 10px;
}
.form_content .item input[type="datetime-local"] {
  /* background: #fbfbfb; */
  border: 1px solid #dddddd;
  height: 32px;
  line-height: 32px;
  width: 302px;
  box-sizing: border-box;
  padding: 0 5px;
}
</style>
